import { styled } from "@mui/material/styles";

export const GridVirtualizedSelectItemContainer = styled("div")(({ theme }) => ({
  display: "flex",
  flex: "none",
  [theme.breakpoints.up("xs")]: {
    flex: "0 0 100%",
  },
  [theme.breakpoints.up("sm")]: {
    flex: `0 0 calc(${100 / 2}% - ${theme.spacing(1 / 2)})`,
  },
  [theme.breakpoints.up("md")]: {
    flex: `0 0 calc(${100 / 3}% - ${theme.spacing(2 / 3)})`,
  },
}));
